<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Pendidikan : Daftar Agensi Pembayaran">
            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="simpan"
                @success="Success"
            >
                <div class="message-box">
                    <w-transition-fade>
                        <w-alert
                            class="my0 text-light"
                            v-if="form.submitted"
                            success
                            no-border
                        >
                            The form is valid, ready to send it!
                        </w-alert>

                        <w-alert
                            class="my0 text-light"
                            v-else-if="form.valid === false"
                            error
                            no-border
                        >
                            Terdapat {{ form.errorsCount }} ralat di dalam
                            borang ini.
                        </w-alert>
                    </w-transition-fade>
                </div>

                <w-dialog
                    v-model="dialog.show"
                    :fullscreen="dialog.fullscreen"
                    :width="dialog.width"
                    :persistent="dialog.persistent"
                    :persistent-no-animation="dialog.persistentNoAnimation"
                    title-class="primary-light1--bg white"
                >
                    <template #title> Tambah Profil </template>
                    <template #default>
                        <w-form
                            ref="form"
                            v-model="dialog.valid"
                            @validate="submitProfil"
                            @success="success"
                        >
                            
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="ID Pengenalan/No. Syarikat*"
                                    name="ID Pengenalan/No. Syarikat*"
                                    v-model="form_profil.no_id"
                                    :validators="[validators.required]"
                                />&nbsp;&nbsp;&nbsp;
                                <z-input
                                    label="Nama*"
                                    name="Nama*"
                                    v-model="form_profil.nama"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Alamat*"
                                    name="Alamat"
                                    v-model="form_profil.alamat1"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat2"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat3"
                                />
                            </w-flex>
                            <z-lookup
                                label="Poskod"
                                name="poskod"
                                :url="service_deposit + 'lookup/lkp_poskod'"
                                :sort="false"
                                :cache="false"
                                v-model="form_profil.lkp_poskod_id"
                                :validators="[validators.required]"
                            /><br />
                            <w-flex
                                justify-center
                                align-center
                                v-if="form_profil.bandar"
                            >
                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Bandar :</h5>
                                    {{ form_profil.bandar }}
                                </div>

                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Negeri :</h5>
                                    {{ form_profil.negeri }}
                                </div>
                                <br />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="No. Telefon"
                                    name="No. Telefon"
                                    v-model="form_profil.no_tel"
                                    :validators="[validators.numeric]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Email"
                                    name="Email"
                                    v-model="form_profil.emel"
                                    
                                />
                            </w-flex>
                            <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                        </w-form>
                    </template>
                    <template #actions>
                        <div class="spacer" />
                        <w-button
                            bg-color="grey-light5--bg"
                            @click="dialog.show = false"
                            >Tutup</w-button
                        >
                        <w-button
                            class="ml1"
                            :loading="dialog.loading"
                            :disabled="dialog.valid === false"
                            @click="$refs.form.validate()"
                            >Daftar</w-button
                        >
                    </template>
                </w-dialog>

                <w-card bg-color="" class="">
                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Agensi </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.pejabat }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Kod Jabatan</h5>
                        <div class="fw-normal my1 fs-1">{{ form.kod }}</div>
                    </div>

                    <div class="xs4">
                      <h5 class="fw-semibold m0">Nama Jabatan</h5>
                        <div class="fw-normal my1 fs-1">
                            {{form.nama}}
                        </div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                  <div class="xs4">
                        <h5 class="fw-semibold m0">No Telefon</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.no_tel}}
                        </div>
                    </div>
                    

                    <div class="xs4">
                       <h5 class="fw-semibold m0">Emel</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.emel }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Alamat
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.lkp_poskod}},{{ form.lkp_bandar}}, {{ form.lkp_negeri}}
                        </div>
                    </div>
                </w-flex>
                </w-card><br><br>

                <!-- </w-from> -->
                <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
                <template #item-content.1>
                    <h3>Profil</h3>
                    <w-flex class="mt3">
                        <div class="xs11">
                            <z-input
                                label="Nama Peminjam / No LBNK / No Id*"
                                name="profil_id"
                                readonly
                                @click="profil"
                                :validators="[validators.required]"
                            />
                        </div>
                        <div class="xs1">&nbsp;
                            <w-icon @click="profil">fal fa-search</w-icon>&nbsp;&nbsp;
                            <!-- <w-icon @click="addProfil">fal fa-plus</w-icon> -->
                        </div>
                    </w-flex>
                <br/>
                <br/>
                    <w-flex justify-center align-center>
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>No</td>
                                        <td width="25%">Nama Pemotong Gaji</td>
                                        <td>Nama Peminjam</td>
                                        <td>No Lbnk</td>
                                        <td>Pusat Pengajian</td>
                                        <td>Pinjaman Dikeluarkan</td>
                                        <td>Jumlah Ansuran Bulanan (RM)</td>
                                        <td>Amaun Patut Kutip (RM)</td>
                                        <td>Kadar Potongan Gaji (RM)</td>
                                        <td>Tindakan&nbsp;&nbsp;<w-checkbox v-model="pilih" @click="cekPilih" class="mr2"></w-checkbox></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in form.pendidik_array">
                                        <td>{{index + 1}}</td>
                                        <td>{{dt.potongan_no_id}} | {{dt.potongan_nama}}</td>
                                        <td>{{dt.no_id}} | {{dt.nama_profil}}</td>
                                        <td>{{dt.no_fail}}</td>
                                        <td>{{dt.pusat_pengajian}}</td>
                                        <td>{{$zutil.currency(dt.jumlah_pinjaman)}}</td>
                                        <td>{{$zutil.currency(dt.jumlah_ansuran_bulanan)}}</td>
                                        <td>{{$zutil.currency(dt.amaun_patut_kutip)}}</td> 
                                        <td>{{$zutil.currency(dt.pendidikan_potongan_amaun)}}</td> 
                                        <td class="align-center">
                                            <w-icon
                                                class="mr1"
                                                @click="padam(dt)"
                                                >fal fa-trash</w-icon
                                            >
                                            &nbsp;&nbsp;
                                            <w-checkbox v-model="dt.pilih"></w-checkbox>
                                        </td>
                                    </tr>
                                    <tr v-for="(dt, index) in pendidikan">
                                        <td></td>
                                        <td>
                                        <z-input
                                            label="Sila Masukan No Kad Pengenalan | Nama *"
                                            name="profil_id"
                                            v-model="dt.potongan_nama"
                                            readonly outline
                                            :validators="[validators.required]" @click="profilP(dt)"
                                        />

                                        </td>
                                        <td>{{dt.no_id}} | {{dt.nama_profil}}</td>
                                        <td>{{dt.no_fail}}</td>
                                        <td>{{dt.pusat_pengajian}}</td>
                                        <td>{{$zutil.currency(dt.jumlah_pinjaman)}}</td>
                                        <td>{{$zutil.currency(dt.amaun_patut_kutip)}}</td> 
                                        <td>{{$zutil.currency(dt.jumlah_ansuran_bulanan)}}</td>
                                        <td>
                                            <z-money 
                                            outline
                                            v-model:originalValue="dt.kadar_potongan"
                                            :validators="[validators.required]">
                                          </z-money>
                                        </td>
                                        <td>
                                            <w-icon
                                                class="mr1"
                                                @click="removePendidikan(index)"
                                                >fal fa-trash</w-icon
                                            >&nbsp;&nbsp;
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>

                <w-flex class="mt3" wrap align-center justify-end>
                    <w-button
                        class="my1"
                        bg-color="warning"
                        @click="back()"
                        >Kembali
                    </w-button>
                    &nbsp;&nbsp;&nbsp;
                    <template v-if="pendidikan != null">
                    <w-button
                        class="my1"
                        type="submit"
                        :disabled="form.valid === false"
                        :loading="form.submitted && !form.sent"
                    >
                        <w-icon dark tile class="mr2">fal fa-save</w-icon>
                        Simpan
                    </w-button>
                    </template>
                    &nbsp;&nbsp;&nbsp;
                    <w-button
                        class="my1"
                        @click="bayar"
                    >
                        <w-icon dark tile class="mr2">fal fa-save</w-icon>
                        Bayar
                    </w-button>
                </w-flex>
                </template>
                <template #item-content.2>
                    <w-flex justify-center align-center>
                            <div class="w-card__content content-hardcode">
                                <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <td width="2%">No</td>
                                            <td width="15%">Tarikh</td>
                                            <td>Pengguna</td>
                                            <td>Status</td>
                                            <td>Catatan</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(dt, index ) in form.jejak_audit" >
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ dt.tarikh }}</td>
                                            <td>{{ dt.user_nama }}</td>
                                            <td>
                                                {{ dt.pendidikan_keterangan }}
                                            </td>
                                            <td>{{ dt.catatan }}</td>
                                        </tr>
                                        <tr v-if="form.jejak_audit.length == 0">
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </w-flex>
                </template>
                </w-tabs>
            </w-form>
            <w-dialog
                v-model="dialogProfil.show"
                :fullscreen="dialogProfil.fullscreen"
                :width="dialogProfil.width"
                :persistent="dialogProfil.persistent"
                :persistent-no-animation="dialogProfil.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Nama Peminjam | No Id | No LBNK
                </template>
                <div class="table-profil-scrol">
                <z-page title="Nama Peminjam | No Id | No LBNK">
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="Nama Peminjam | No Id | No LBNK"
                                v-model="carian_profil_peminjam.q">
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button 
                                class="ml1" 
                                :loading="dialog.loading"
                                @click="cariProfilPeminjam">Cari
                            </w-button>
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No Id | Nama
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No LBNK
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in draf_pendidikan">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{dt.nama_profil}} | {{dt.no_id}}
                                    </td>
                                    <td class="w-table__cell">
                                        {{dt.no_fail}}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-button
                                            class="my1"
                                            v-model="form.profil_id"
                                            @click="pilihProfil(dt)"
                                            >Pilih
                                        </w-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </z-page><br><br>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogProfil.show = false"
                        >Tutup
                    </w-button>
                </template>
            </w-dialog>
            <w-dialog
                v-model="pilihPemotong.show"
                :fullscreen="pilihPemotong.fullscreen"
                :width="pilihPemotong.width"
                :persistent="pilihPemotong.persistent"
                :persistent-no-animation="pilihPemotong.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Nama Pemotong Gaji
                </template>
                <div class="table-profil-scrol">
                <z-page title="No Id | Nama Pemotong Gaji">
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No Id | Nama Pemotong Gaji"
                                v-model="carian_profil.q">
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button 
                                class="ml1" 
                                :loading="pilihPemotong.loading"
                                @click="cariPemotong">Cari
                            </w-button>
                            &nbsp;&nbsp;
                            <w-icon  @click="profilNew">fal fa-plus</w-icon>
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No KP | Nama
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in profils">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{dt.label}}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-button
                                            class="my1"
                                            v-model="form.profil_id"
                                            @click="klikPemotong(dt)"
                                            >Pilih
                                        </w-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </z-page>
            </div>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="pilihPemotong.show = false"
                        >Tutup
                    </w-button>
                </template>
            </w-dialog>

             <w-dialog v-model="dialogProfilNew.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                     Tambah Profil
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submitProfilNew" @success="success">
                        <template ></template><br>

                        <w-flex justify-space-between class="mb4">
                            <div class="xs4">
                           <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                            </div>

                           </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. KP/No. Syarikat *"  
                              name="No. ID" 
                              v-model="form_profil.no_id" 
                              :validators="[validators.required]"/>
                            <z-input 
                              label="Nama *" 
                              name="Nama" 
                              v-model="form_profil.nama" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Alamat *" 
                              name="Alamat" 
                              v-model="form_profil.alamat1" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat2" 
                              v-model="form_profil.alamat2" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat3" 
                              v-model="form_profil.alamat3" />
                        </w-flex>
                        <z-lookup 
                              label="Poskod" 
                              name="poskod" 
                              :url='service_bil_pelbagai+"lookup/lkp_poskod"' 
                              :sort="false" :cache="false"
                              v-model="form_profil.lkp_poskod_id"/><br>
                            <w-flex justify-center align-center>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Bandar : &nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.bandar}}</td>
                                  </tr>
                              </div>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Negeri :&nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.negeri}}</td>
                                  </tr>
                              </div>
                            </w-flex><br>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. Telefon" 
                              name="No. Telefon" 
                              v-model="form_profil.no_tel" 
                              :validators="[validators.numeric]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Emel"  
                              name="Email" 
                              v-model="form_profil.emel"/>
                        </w-flex>
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialogProfilNew.show = false">Tutup</w-button>
                    <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">Simpan</w-button>
                </template>
            </w-dialog>




        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            isHidden: false,
            resourceurl: this.service_tunggakan + "pendidikan-agensi/agensi-pembayar",
            reload: true,
            files: [],
            form_profil: {},
            draf_pendidikan: {},
            draf_potongan: {},
            form_cari: {},
            carian_profil: { q: "" },
            carian_profil_peminjam: { q: "" },
            carian_profil_pemotong: { q: "" },
            profils: [],
            pendidikan: [],
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
            dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
            dialogProfilNew: {
                  valid: false,
                  show: false,
                  fullscreen: false,
                  persistent: true,
                  persistentNoAnimation: false,
                  loading: false,
                  width: 800,
                  form: {nama: '', email: ''}
            },
            kategori: [
                {
                    value: 1,
                    label: "Individu",
                },
                {
                    value: 2,
                    label: "Syarikat",
                },
            ],
            pilihPemotong: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
            form : {
              loading: false,
            },
            loading: false,
            selection: true,
            i_ind : null,
            id : null,
            tabs: [
                { title: "Butiran Bayaran", content: "" },
                { title: "Jejak Audit", content: "" },
            ],
            activeTab : 0,
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Pendidikan", route: "/pendidikan" },
                { label: "Agensi Pembayaran", route: "/pendidikan/agensi" },
                { label: "Daftar Agensi Pembayaran", route: "/pendidikan/agensi" + this.id },
            ],
            validators: {
                required: (value) => !!value || "Medan ini wajib diisi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
        };
    },
    methods: {
        profilNew(){
          this.dialogProfilNew.show = 1
        },
        submitProfilNew() {
        
            if (this.dialog.valid == true) {
            //     this.form.valid = false

            // if (this.$refs.form.validate()) {
                this.dialog.loading = true

                
                    this.$zcomm.post(this.service_bil_pelbagai+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          this.mapreturneddata(res)
                          this.dialogProfilNew.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          // this.form.profil_id = res.id;
                          // this.form.no_id = res.no_id;
                          // this.form.nama = res.nama;
                          // this.form.alamat1 = res.alamat1;
                          // this.form.alamat2 = res.alamat2;
                          // this.form.alamat3 = res.alamat3;
                          // this.form.poskod = res.poskod;
                          // this.form.bandar = res.bandar;
                          // this.form.negeri = res.negeri;
                          // this.form.kategori = res.kategori;
                            // this.$inertia.visit(this.$page.url)
                          for (var j in this.pendidikan) {
                                if(this.pendidikan[j].pendidikan_id == this.pendidikan_id){
                                this.pendidikan[j].potongan_profil_id = res.id;
                                this.pendidikan[j].potongan_nama = res.no_id + ' | ' +res.nama;
                                }
                            }
                          
                        })
                        .finally(() => {
                            this.dialog.loading = false;
                          this.dialogProfilNew.show = false;
                          this.pilihPemotong.show = false;
                          
                          // $('#' + this.resourceurl).modal('hide')
                        });
                        this.cariProfil();
                
            }
        },
        poskodDetail() {
      
        this.$zcomm.get(this.service_bil_pelbagai+'lookup/lkp_poskod_detail/'+this.form_profil.lkp_poskod_id).then(res => {
                  this.form_profil.negeri = res.negeri;
                  this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
                  this.form_profil.bandar = res.bandar;
                  this.form_profil.lkp_jenis_alamat_id = 1;
                });
        },
        addProfil(dt) {
            this.dialog.show = 1;
        },
        submitProfil() {
            if (this.dialog.valid == true) {
            this.dialog.loading = true;

            this.$zcomm
                .post(this.service_deposit + "profil", this.form_profil)
                .then((res) => {
                    this.dialog.show = false;
                    console.log(res)
                    //update displayed record
                    this.$page.flash.success = "Rekod telah ditambah"
                    this.mapreturneddata(res);
                    this.dialog.show = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.form.profil_id = res.id;
                    this.form.kategori = res.kategori;
                    this.form.no_id = res.no_id;
                    this.form.nama = res.nama;
                    this.form.alamat1 = res.alamat1;
                    this.form.alamat2 = res.alamat2;
                    this.form.alamat3 = res.alamat3;
                    this.form.poskod = res.poskod;
                    this.form.bandar = res.bandar;
                    this.form.negeri = res.negeri;
                    this.form.keterangan = res.keterangan;
                    this.form.aras_akhir = res.aras_akhir;
                    // this.$inertia.visit(this.$page.url)
                })
                .finally(() => {
                    this.dialog.loading = false;
                    this.dialog.show = false;
                    this.$inertia.visit(this.$route('pendidikan-agensi.agensi.show', this.form.id))

                    // $('#' + this.resourceurl).modal('hide')
                });

            }
        },
        profil() {
            this.dialogProfil.show = 1;
        },

        cariProfil() {
            if (this.carian_profil.q.length > 1) {
                this.$zcomm.post(this.service_utiliti + "lookup/profil", this.carian_profil,{})
                    .then((res) => {
                        console.log(res);
                        this.profils = res;
                    });
            }
        },
        cariProfilPeminjam() {
            this.dialogProfil.loading = true;
            if (this.carian_profil_peminjam.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_tunggakan + "pendidikan-agensi/profil",
                        this.carian_profil_peminjam,
                        {}
                    )
                    .then((res) => {
                    console.log(res.data);
                        this.draf_pendidikan = res.pendidikan;
                        // this.draf_potongan = res.potongan;
                        this.dialogProfil.loading = false;
                    });
                    
            }
        },
        profilP(item) {
            //pendidikan_id draf
            this.pendidikan_id = item.pendidikan_id;
            this.pilihPemotong.show = 1;
        },
        cariPemotong() {
            if (this.carian_profil.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/profil",
                        this.carian_profil,
                        {}
                    )
                    .then((res) => {
                        console.log(res);
                        this.profils = res;
                    });
            }
        },
        klikPemotong(dt) {
            this.form_cari.id = dt.value;
            this.pemotongDetail();
        },
        pemotongDetail() {
            this.$zcomm
                .get(this.service_deposit + "profil/" + this.form_cari.id)
                .then((res) => {
                    for (var j in this.pendidikan) {
                        if(this.pendidikan[j].pendidikan_id == this.pendidikan_id){
                        this.pendidikan[j].potongan_profil_id = res.id;
                        this.pendidikan[j].potongan_nama = res.no_id + ' | ' +res.nama;
                        }
                    }
                })
                .then((res) => {
                    this.carian_profil.q = null;
                    this.profils = null;
                    this.pilihPemotong.show = false;
                });
        },
        
        pilihProfil(dt) {
            this.form_cari.id = dt.id;
            this.profilDetail();
        },
        profilDetail() {
            this.$zcomm
                .get(this.service_tunggakan + "pendidikan-agensi/pilih-profil" + "?profil_id=" + this.form_cari.id)
                .then((res) => {
                    console.log(res.data);
                    this.loading = false
                    if(res.code > 0){
                        this.a = res.data.jumlah_ansuran_bulanan * res.data.bil_bulan_semasa;
                        this.b = this.a - res.data.baki_pinjaman;
                        this.amaun_patut_kutip = this.b - res.data.jumlah_ansuran_bulanan;

                        if (res.data) {
                            this.form.pendidikan_id = res.data.id;
                            this.form.jumlah_ansuran_bulanan = res.data.jumlah_ansuran_bulanan;
                            this.form.kadar_potongan = res.data.jumlah_ansuran_bulanan;
                            this.form.jumlah_pinjaman = res.data.jumlah_pinjaman;
                            this.form.no_fail = res.data.no_fail;
                            this.form.pusat_pengajian = res.data.pusat_pengajian;
                            this.form.profil_id = res.data.profil_id;
                            this.form.nama_profil = res.data.nama_profil;
                            this.form.potongan_nama = res.data.potongan_nama;
                            this.form.potongan_no_id = res.data.potongan_no_id;
                            this.form.pendidikan_potongan_amaun = res.data.pendidikan_potongan_amaun;
                            this.form.no_id = res.data.no_id;
                            var proses = 1;

                            for (var j in this.form.pendidik_array) {
                                if(res.data.id == this.form.pendidik_array[j].id){
                                    proses = 0;
                                    this.$zutil.notify('Rekod sudah pilih!', false);
                                    this.dialogProfil.show = false;
                                }
                            }
                            for (var w in this.pendidikan) {
                                if(res.data.id == this.pendidikan[w].pendidikan_id){
                                    proses = 0;
                                    // this.$zutil.notify('Hanya Boleh pilih 1 rekod saja!', false);
                                    this.dialogProfil.show = false;
                                }

                            }
                            if(proses == 1){
                                this.pendidikan.push({
                                    pendidikan_id: res.data.id,
                                    jumlah_ansuran_bulanan: res.data.jumlah_ansuran_bulanan,
                                    kadar_potongan: res.data.jumlah_ansuran_bulanan,
                                    jumlah_pinjaman: res.data.jumlah_pinjaman,
                                    no_fail: res.data.no_fail,
                                    pusat_pengajian: res.data.pusat_pengajian,
                                    profil_id: res.data.profil_id,
                                    nama_profil: res.data.nama_profil,
                                    no_id: res.data.no_id,
                                    amaun_patut_kutip: this.amaun_patut_kutip,
                                    potongan_nama : res.data.potongan_nama,
                                    potongan_profil_id : res.data.profil_id,
                                    potongan_no_id : res.data.potongan_no_id,
                                    pendidikan_potongan_amaun : res.data.pendidikan_potongan_amaun,
                                });
                                this.$zutil.notify('Berjaya Di pilih');
                            }
                            // }

                            this.form.pendidikan = this.pendidikan;
                            this.dialogProfil.show = false;
                            this.carian_profil_peminjam.q = null;
                            this.draf_pendidikan = null;
                        }
                    }else{
                        this.$zutil.notify('Tidak Ada Rekod', false);
                        this.dialogProfil.show = false;
                    }

                });
        },

        removePendidikan(index) {
            this.form.pendidikan.splice(index, 1);
        },

        simpan(tindakan) {
            if(this.form.valid == true){
                this.form.loading = true
                this.form.tindakan = 1;
                this.form.pendidikan = this.pendidikan;
                var param = {
                  id : this.form.id,
                  pendidikan_jabatan_id : this.form.pendidikan_jabatan_id,
                  pendidikan : this.pendidikan,
                }
                    this.$zcomm.post(this.resourceurl + '/simpan/'+this.form.id, param)
                    .then((res) => {
                        if (typeof this.onAfterEdit === "function") {
                            this.onAfterEdit();
                        }
                        this.$inertia.visit(this.$route('pendidikan-agensi.agensi.show', this.form.id))
                    })
                    .catch((err) => {})
                    .finally(() => {
                            this.$zutil.notify ("Data Berjaya Disimpan.")
                            this.form.loading = false
                    });
            }
        },
        clear () {
            this.getData()
            this.files = false
            this.$nextTick(() => {
                this.files = true
            })
        },
        cekPilih(){
            for (var i in this.form.pendidik_array) {
                this.form.pendidik_array[i].pilih = this.pilih
            }
        },

        padam(dt){
            var yakin = confirm("Apakah Anda Yakin?");

            if (yakin) {
                var param = {
                  id : dt.id,
                  pendidikan_pejabat_id : this.form.id,
                }
                this.$zcomm
                    .post(this.resourceurl + '/padam/'+this.form.id, param)
                    .then(res => {
                        // this.$inertia.visit(this.$route('pendidikan-agensi.agensi.show', this.form.id))
                    })
                    .finally(() => {
                      this.$zutil.message('Berjaya Di Padam!', false)
                        this.getData();
                    });
            } else {
                this.$zutil.notify('Batal Di Padam!', false);
            }
        },

        getData()  {
          var app = this;

          if(this.id){
            if(this.id > 0){
              this.$zcomm.get(this.service_tunggakan +'pendidikan-agensi/agensi-pembayar/'+this.id+''+window.location.search).then(res => {
                this.form = res;

              })
              .finally(() => {

                this.loading = false
              });
            }
          }
          
          
        },


        bayar() {
            var id = '';
            for (var i in this.form.pendidik_array) {
                if(this.form.pendidik_array[i].pilih == true){
                        id = this.form.pendidik_array[i].id+','+id
                }
            }
            if(id){
                window.location.href = 'bayar/'+this.form.id +
                                "?pendidikan_id=" +id;
            }else{
                alert('sila pilih dulu.')
            }
        },
        back(){
               this.$inertia.visit(this.$route('pendidikan-agensi.agensi.index'));
        }

    },
    watch: {
        files: function (val) {
            // console.log(val);
            console.log("work");
        },
        "form_cari.id": function (q) {
            this.profilDetail();
        },
        'form_profil.lkp_poskod_id': function(q) {
                this.poskodDetail();
        },

    },
    mounted() {
        this.dialog.width = 900;
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
